import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BadgeCheck, Check, Gift, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

/** Avis envoyés depuis les fiches produit : à valider (publication + code -10 % envoyé à l'autrice) ou refuser. */
export function PendingReviews() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["admin-reviews-pending"], queryFn: async () => (await api.get("/admin/reviews/pending")).data });
  const { data: g } = useQuery({ queryKey: ["admin-growth"], queryFn: async () => (await api.get("/admin/growth")).data });
  const list = Array.isArray(data) ? data : [];
  const act = async (id, action) => {
    try {
      const { data: r } = await api.post(`/admin/reviews/${id}/${action}`);
      toast.success(action === "approve" ? `Avis publié${r?.reward_code ? ` · code ${r.reward_code} envoyé` : ""}` : "Avis refusé");
      qc.invalidateQueries();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section data-testid="admin-pending-reviews" className="mb-10">
      <div className="mb-4 flex flex-wrap gap-6 text-sm text-[var(--parchment)]/85">
        <span>Inscrites (offre bienvenue) : <b data-testid="admin-growth-newsletter">{g?.newsletter ?? 0}</b></span>
        <span>Guides anti-chute envoyés : <b data-testid="admin-growth-guide-leads">{g?.guide_leads ?? 0}</b></span>
        <span>Marraines : <b data-testid="admin-growth-referrers">{g?.referrers ?? 0}</b></span>
        <span>Commandes parrainées : <b data-testid="admin-growth-referral-orders">{g?.referral_orders ?? 0}</b></span>
        <span>Avis récompensés : <b data-testid="admin-growth-rewarded">{g?.rewarded_reviews ?? 0}</b></span>
      </div>
      <p className="font-display text-2xl">Avis à valider <span className="text-[var(--gold-soft)]">({list.length})</span></p>
      <p className="mt-1 text-sm text-[var(--muted)]">En validant, l'avis est publié et la cliente reçoit automatiquement son code -10 % (60 jours, usage unique).</p>
      {!list.length ? <p data-testid="admin-pending-empty" className="mt-4 text-sm">Aucun avis en attente.</p> : (
        <ul className="mt-4 space-y-3">
          {list.map((r) => (
            <li key={r.id} data-testid={`admin-pending-review-${r.id}`} className="rounded-sm border border-[var(--line)] p-4">
              <p className="text-sm"><b>{r.name}</b> · {r.rating}/5 · {r.product_slug} · <span className="text-[var(--muted)]">{r.email}</span>{r.verified ? <span className="ml-2 inline-flex items-center gap-1 text-xs text-[var(--gold-soft)]"><BadgeCheck className="h-3.5 w-3.5" />Achat vérifié</span> : null}</p>
              <p className="mt-2 text-sm text-[var(--parchment)]/90">{r.text}</p>
              <div className="mt-3 flex gap-2">
                <button data-testid={`admin-review-approve-${r.id}`} onClick={() => act(r.id, "approve")} className="inline-flex items-center gap-1.5 rounded-full bg-[var(--gold)] px-4 py-2 text-xs font-semibold text-[var(--ink)]"><Check className="h-3.5 w-3.5" /><Gift className="h-3.5 w-3.5" />Publier + envoyer le code</button>
                <button data-testid={`admin-review-reject-${r.id}`} onClick={() => act(r.id, "reject")} className="inline-flex items-center gap-1.5 rounded-full border border-[var(--line)] px-4 py-2 text-xs"><X className="h-3.5 w-3.5" />Refuser</button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
